export default "__VITE_ASSET__051d12f3__"